import { MyPrivacySection } from '../settings/MyPrivacySection';
import styles from './SettingsPage.module.css';

/**
 * The Settings tab — per-user, self-service preferences, visible to ALL users
 * (backend _TAB_DEFINITIONS: "settings" → "everyone"). The first (and, for now,
 * only) group is My CRM Privacy: each user manages the personal contacts THEY
 * added to the firm suppression list. Structured as a list of groups so future
 * self-service settings slot in without a re-layout.
 */
export function SettingsPage() {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h1 className={styles.title}>Settings</h1>
        <div className={styles.subtitle}>
          Your personal preferences. Only you can see and change these.
        </div>
      </div>

      <div className={styles.groupLabel}>Privacy</div>
      <div className={styles.groups}>
        <MyPrivacySection />
      </div>
    </div>
  );
}
